/* eslint-disable react/jsx-props-no-spreading */
import { FormInstance } from 'antd';
import React from 'react';
import TannerForm from './Tanner';

interface SpecificFormProps {
  createPurchaseIntentLoading: boolean;
  handleChangeRut: (rut: string) => Promise<string>;
  form: FormInstance<unknown>;
}

const renderConcessionaireForm = (sharedProps: SpecificFormProps) => {
  return <TannerForm {...sharedProps} />;
};

export default renderConcessionaireForm;
